import React from 'react'

export interface TvMinimalPlayIconProps extends React.SVGProps<SVGSVGElement> {
    size?: number
    strokeWidth?: number
}

// lucide's `tv-minimal-play` (a screen with a play mark on a stand), drawn
// here because the installed lucide-react predates it. Same props as a
// lucide icon so it drops into the media dropdowns beside them.
export default function TvMinimalPlayIcon({
    size = 24,
    strokeWidth = 2,
    className,
    ...props
}: TvMinimalPlayIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            {...props}
        >
            <path d="M15.033 9.44a.647.647 0 0 1 0 1.12l-4.065 2.352a.645.645 0 0 1-.968-.56V7.648a.645.645 0 0 1 .967-.56z" />
            <path d="M7 21h10" />
            <rect width="20" height="14" x="2" y="3" rx="2" />
        </svg>
    )
}
